import { useEffect, useState, useId } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils"; // 프로젝트 공통 유틸
import { Page, Group, Layout, Button } from "@/comn/components"; // 화면 구성 컴포넌트
import { useForm, useFetch, useModal, useStore, useToast, useGrid, useResource, usePage, usePopup } from "@/comn/hooks"; // hook
import {
    BASE,
    APIS,
    SF_ERR_NTC_DTL_FORM,
    SG_ERR_NTC_DTL_GRID,
} from "@/tz/go/egaz/osci/lpco/cscl/services/OsciNtcErrService";

import { Grid } from "@/comn/components";

export const OSCI0202003Q = (props: any) => {
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const toast = useToast();
    const { state } = useLocation();
    const { data } = useParams();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid });
    const { getParams } = usePopup();

    useResource({
        defaultSchema: [
            { area: "cntyCd" },
            { area: "hsCd" },
            { area: "cstmCd" },
            { area: "comnCd", comnCd: "OSC0045" },
            { area: "comnCd", comnCd: "OSC0044" },
            { area: "comnCd", comnCd: "OSC0024" },
        ],
    });

    const form = {
        errNtcDtlForm: useForm({
            defaultSchema: SF_ERR_NTC_DTL_FORM,
            defaultValues: { errNtcFrom: comnUtils.getDate({ d: -7 }), errNtcTo: comnUtils.getDate() },
        }),
    };

    const grid = {
        errNtcDtlGrid: useGrid({
            defaultSchema: SG_ERR_NTC_DTL_GRID,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getErrNtcDtl: useFetch({
            api: (page = grid.errNtcDtlGrid.page) => {
                return APIS.getErrNtcDtl(form.errNtcDtlForm.getValues(), page, grid.errNtcDtlGrid.size);
            },
            enabled: comnUtils.isEmpty(form.errNtcDtlForm.errors) && form.errNtcDtlForm.isSubmitted,
            key: [grid.errNtcDtlGrid.page, grid.errNtcDtlGrid.size],
            onSuccess: (data) => {
                setStore(pgeUid, {
                    form: form.errNtcDtlForm.getValues(),
                    page: grid.errNtcDtlGrid.page,
                    size: grid.errNtcDtlGrid.size,
                });
            },
            onError: () => {},
            showToast: true,
        }),
    };

    const handler = {
        getErrNtcDtl: () => {
            form.errNtcDtlForm.handleSubmit(
                (data) => {
                    fetch.getErrNtcDtl.fetch();
                },
                (data) => {
                    toast.showToast({ type: "warning", content: "msg.osc.00003" });
                },
            )();
        },
    };

    useEffect(() => {
        const param = getParams()?.reffTin;
        console.log("param :: " + JSON.stringify(param));

        form.errNtcDtlForm.setValue("reffTin", getParams()?.reffTin);
        form.errNtcDtlForm.setValue("reffYy", getParams()?.reffYy);
        form.errNtcDtlForm.setValue("reffSrno", getParams()?.reffSrno);

        const reffNo = getParams()?.reffTin + "-" + getParams()?.reffYy + "-" + getParams()?.reffSrno;
        form.errNtcDtlForm.setValue("reffNo", reffNo);

        handler.getErrNtcDtl();
    }, []);

    const render = {
        grid_errNtcDtl: {
            head: {},
            cell: {
                erkyCn4: (props: any) => {
                    const { binding, rowValues, value } = props;
                    if (rowValues.erkyCn2 == 0 && rowValues.erkyCn3 == 0) {
                        return "General";
                    } else if (rowValues.erkyCn2 > 0 && rowValues.erkyCn3 == 0) {
                        return "Item";
                    } else if (rowValues.erkyCn2 > 0 && rowValues.erkyCn3 > 0) {
                        return "Model";
                    }
                },
            },
        },
    };

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Label {...form.errNtcDtlForm.schema.referenceNo}></Group.Label>
                            <Group.Field size={4}>
                                <Group.Control {...form.errNtcDtlForm.schema.reffTin} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.errNtcDtlForm.schema.reffYy} />
                                <Group.Any>-</Group.Any>
                                <Group.Control {...form.errNtcDtlForm.schema.reffSrno} />
                            </Group.Field>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Title title={"T_ERR_NTC_DTL"} titleSize={1}></Group.Title>
                        <Group.Row>
                            <Group.Control {...form.errNtcDtlForm.schema.reffNo}></Group.Control>
                            <Group.Control {...form.errNtcDtlForm.schema.errNtcDtm}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Grid
                        {...grid.errNtcDtlGrid.grid}
                        data={fetch.getErrNtcDtl.data?.errNtcDtl}
                        render={render.grid_errNtcDtl}
                    />
                </Group.Body>
            </Group>
        </Page>
    );
};
